import styled, { css } from 'styled-components';
import { Account, Dropdown, Loader, Navigation, Option } from '@sapiens/insured-component-library';
import { MediaBreakpoints, spacing } from 'common/utils/helpers/theme.helpers';
import { Link } from 'common/components/link/link';

/**
 * -------------------General header styling-------------------
 */
export const HeaderNavigation = styled(Navigation)`
  height: 85px;
  max-width: 100%;
  border: none;
  background-color: ${({ theme }) => theme.customColors.F999};

  ${MediaBreakpoints.down('md')} {
    height: 64px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
`;

export const HeaderLogoContainer = styled.a`
  width: 184px;
  height: 33px;
  padding: 0 20px;
  text-decoration: none;
  ${MediaBreakpoints.down('md')} {
    padding: 0;
  }
`;

interface HeaderLinkProps {
  isActive?: boolean;
}

const ActiveLinkCss = css`
  border-bottom: 2px solid ${({ theme }) => theme.customColors.F998};
`;

export const HeaderLink = styled.a<HeaderLinkProps>`
  width: max-content;
  padding: ${spacing(1)};
  font-family: 'Eina 03';
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  text-decoration: none;
  color: ${({ theme }) => theme.customColors.F999};
  ${({ isActive }) => isActive && ActiveLinkCss};

  &:hover {
    color: ${({ theme }) => theme.customColors.F999};
    text-decoration: none;
    ${ActiveLinkCss};
  }
`;

export const HeaderLinkSection = styled.div`
  margin-left: 30px;
  display: flex;
  ${HeaderLink} {
    margin: 0 12px;
  }

  ${MediaBreakpoints.down('md')} {
    display: none;
  }
`;

export const HeaderAccountIcon = styled(Account)`
  font-family: 'Eina 03';
  width: 68px;
  height: 68px;
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.customColors.F999};
`;

export const HeaderAccountSection = styled.div`
  margin-right: ${spacing(6)};
  display: flex;
  flex-direction: row;
  align-items: center;

  ${MediaBreakpoints.down('md')} {
    display: none;
  }
`;

export const HeaderLanguageSection = styled.div`
  ${MediaBreakpoints.down('md')} {
    display: none;
  }
`;

export const SeeProfileLink = styled.div`
  white-space: nowrap;
  margin-bottom: ${spacing(1)};
`;

export const AccountDropdownItem = styled(Option)`
  min-width: 160px !important;
  padding-right: 0 !important;
  padding-left: ${spacing(6)} !important;
  padding-top: ${spacing(3)} !important;
  padding-bottom: ${spacing(3)} !important;
  background-color: ${({ theme }) => theme.palette.neutral.white} !important;
  & :hover {
    background-color: ${({ theme }) => theme.palette.neutral.white} !important;
  }
`;

export const DropDownImage = styled.div`
  width: 34px;
  margin-right: 12px;
  line-height: 0;
`;

export const AccountDropdownContainer = styled(Dropdown)`
  margin: 0 ${spacing(2)};
  background-color: ${({ theme }) => theme.customColors.F999} !important;
  border: none !important;
  height: 5rem;
  justify-content: flex-end;
  & fieldset {
    display: none;
  }
  .account-dropdown-display-name {
    white-space: normal;
    margin-right: ${spacing(2)};
  }

  border-color: none !important;
  box-shadow: none !important;
  border: none !important;
`;

export const HeaderLinkContainer = styled.div`
  width: max-content;
  display: flex;
  flex-direction: row;
  ${MediaBreakpoints.down('md')} {
    display: none;
  }

  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #eaeaea;
  border-radius: 6px;
  cursor: pointer;
`;

export const StyledLink = styled(Link)`
  font-family: 'Eina 03';
  margin-top: ${spacing(2)};
  color: ${({ theme }) => theme.palette.neutral.white} !important;
  text-decoration: none !important;
`;

export const FileClaimLinkButton = styled.div`
  color: ${({ theme }) => theme.palette.neutral.white} !important;
  text-decoration: none !important;
  white-space: nowrap;
`;

export const StyledLoader = styled(Loader)`
  ${MediaBreakpoints.down('md')} {
    display: none;
  }
`;
